<!--
 * @Author:
 * @Description: Custom Radio Component
 * @Date: 2025-04-01 20:14:48
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/components/common/form/custom-radio.vue
-->

<template>
  <div class="custom-radio-container">
    <div class="custom-radio-header" v-if="label">
      <span class="custom-radio-label">{{ label }}</span>
      <el-tooltip v-if="showInfoTips" :content="infoTips" placement="top">
        <!-- /Users/niulin/Desktop/前端项目/rhcn-merchant-web/src/assets/image/common/icon-tool_Info.svg -->
        <img v-if="!$slots.infoIcon" class="info-icon" src="@/assets/image/common/tool_Info.png" alt="info icon">
        <slot name="infoIcon" />
      </el-tooltip>
    </div>
    <div class="custom-radio-options">
      <div v-for="(item, index) in options" :key="index" class="custom-radio-item"
        :class="{ 'is-selected': value === getItemValue(item) }" @click="handleSelect(item)">
        <div class="radio-circle">
          <div class="radio-inner" v-if="value === getItemValue(item)"></div>
        </div>
        <!-- TODO: 这里需要优化后续兼容不存在描述的情况 -->
        <div class="radio-content">
          <div class="radio-title">{{ getItemLabel(item)
          }}</div>
          <div class="radio-desc" v-if="getItemDesc(item)">{{ getItemDesc(item) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomRadio',
  props: {
    // Radio options array
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    // Label for the radio group
    label: {
      type: String,
      default: '',
    },
    // Whether to show the info icon with tooltip
    showInfoTips: {
      type: Boolean,
      default: false,
    },
    // Content for the info tooltip
    infoTips: {
      type: String,
      default: '',
    },
    // Value model (v-model)
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    // Object mapping for value property name
    valueKey: {
      type: String,
      default: 'value',
    },
    // Object mapping for label property name
    labelKey: {
      type: String,
      default: 'label',
    },
    // Object mapping for description property name
    descKey: {
      type: String,
      default: 'desc',
    },
  },
  methods: {
    // Handle radio item selection
    handleSelect(item) {
      const value = this.getItemValue(item);
      const label = this.getItemLabel(item);
      this.$emit('input', value);
      this.$emit('change', value, label, item);
    },
    // Get item value from option object or use option directly if primitive
    getItemValue(item) {
      return typeof item === 'object' && item !== null
        ? (item[this.valueKey] !== undefined ? item[this.valueKey] : item)
        : item;
    },
    // Get item label from option object or use option directly if primitive
    getItemLabel(item) {
      return typeof item === 'object' && item !== null
        ? (item[this.labelKey] !== undefined ? this.$t(item[this.labelKey]) : item.toString())
        : item.toString();
    },
    // Get item description from option object
    getItemDesc(item) {
      return typeof item === 'object' && item !== null
        ? this.$t(item[this.descKey])
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-radio-container {
  width: 100%;
  background: #F9FAFB;
  border-radius: 8px 8px 8px 8px;
  padding: 24px;

  .custom-radio-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    .custom-radio-label {

      font-weight: bold;
      font-size: 16px;
      color: #1A202C;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 8px;

    }

    .info-icon {
      width: 16px;
      height: 16px;
    }
  }

  .custom-radio-options {
    .custom-radio-item {
      display: flex;
      align-items: flex-start;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        border-color: #C0C4CC;
      }

      .radio-circle {
        position: relative;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #DCDFE6;
        margin-right: 8px;

        .radio-inner {
          position: absolute;
          top: 3px;
          left: 3px;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #00A2DD;
        }
      }

      &.is-selected .radio-circle {
        border-color: #00A2DD;
      }

      .radio-content {
        flex: 1;

        .radio-title {
          font-weight: 400;
          font-size: 16px;
          color: #1A202C;
          margin-bottom: 8px;
        }

        .radio-desc {

          font-weight: 400;
          font-size: 12px;
          color: #8D98AF;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
}
</style>
